export default ['productsRequestStatus', 'originatorsRequestStatus'];
